import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿SAINT® requiere una resonancia magnética (fMRI)?",
    answer:
      "Sí. SAINT® utiliza una fMRI para identificar de forma individualizada el circuito cerebral asociado con la depresión en cada paciente. La fMRI forma parte del protocolo.",
  },
];

export const esDoesSaintRequireMri = makeEsArticle({
  slug: "does-saint-tms-require-an-mri",
  title: "¿SAINT® requiere una resonancia magnética (fMRI)?",
  description:
    "Sí. SAINT® utiliza una fMRI para personalizar el objetivo de estimulación de cada paciente. La fMRI forma parte del protocolo.",
  h1: "¿SAINT® requiere una resonancia magnética (fMRI)?",
  breadcrumbLabel: "¿SAINT® requiere fMRI?",
  shortAnswer:
    "Sí. SAINT® utiliza una resonancia magnética funcional (fMRI) para identificar de forma individualizada el circuito cerebral asociado con la depresión en cada paciente. Esta fMRI es parte del protocolo y se realiza antes de la semana de tratamiento. La TMS convencional no utiliza fMRI; ubica el objetivo con mediciones del cuero cabelludo. SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
  keyTakeaways: [
    "SAINT® requiere una fMRI.",
    "La fMRI personaliza el objetivo de estimulación.",
    "Se realiza antes de la semana de tratamiento.",
    "La TMS convencional no usa fMRI.",
    "SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos.",
  ],
  sections: [
    {
      heading: "El papel de la fMRI",
      paragraphs: [
        "La fMRI mapea las redes cerebrales relacionadas con la depresión. El software identifica el punto exacto del circuito de la corteza prefrontal dorsolateral asociado con la depresión en cada persona, y la bobina se coloca en ese objetivo durante cada sesión mediante neuronavegación.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
